const performAnimateHeight = (element) => {
  // Track our starting height
  const startHeight = element.offsetHeight;

  // Wait for animation frame (that should trigger after our
  // block that causes our layout changes has been invoked)
  requestAnimationFrame(() => {
    // Track our ending height
    const endHeight = element.offsetHeight;

    // Reset height to start height
    element.style.height = startHeight + 'px';

    // We need to wait for an animation frame so the
    // starting height "sticks" and the CSS transitions
    // trigger properly
    requestAnimationFrame(() => {
      // Set height to ending height and let
      // CSS transitions take care of the magic
      element.style.height = endHeight + 'px';
    });
  });
};

const animateHeight = (elements, block) => {
  let $elements = elements;

  // Allow passing a single element or an array as
  // the argument `elements`
  if (!Array.isArray(elements))
    $elements = [elements];

  // Prepare all of our animations
  $elements.forEach((el) => performAnimateHeight(el));

  // Invoke the block that will cause a layout change
  block();
}

const fixHeight = (element) => {
  // Take an auto height element and fix it to whatever static
  // height it currently is so that we can use CSS transitions
  // to hide it
  element.style.height = element.offsetHeight + 'px';
  element.style.flexGrow = '0';
  element.style.flexShrink = '0';
}

export { animateHeight, fixHeight };
